var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-flex d-print-none ml-1"},[(_vm.orderColumn == _vm.column)?[(_vm.isSortDesc)?_c('ChevronDownIcon',{staticClass:"text-black",attrs:{"size":"18"}}):_c('ChevronUpIcon',{staticClass:"text-black",attrs:{"size":"18"}})]:_c('SortIcon',{staticClass:"text-black",attrs:{"size":"15"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }